import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LoadingView = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "560px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "52px",
          height: "52px",
          border: "5px solid rgba(23, 38, 100, 0.2)",
          borderTopColor: theme.palette.primary.main,
          borderRadius: "50%",
          animation: "ipAddressImportSpin 0.8s linear infinite",
          "@keyframes ipAddressImportSpin": {
            to: { transform: "rotate(360deg)" },
          },
        }}
      />
    </Box>
  );
};

export default LoadingView;
